import useAuthStore from '@/features/auth/stores/authStore';
import { IntrospectUserResponse, useIntrospect } from '@/hooks/useIntrospect';
import React from 'react';
import { Outlet } from 'react-router';
import { Loading } from './Loading';

export const MainLayout = () => {
  const [setDomainUser] = useAuthStore((x) => [x.setDomainUser, x.hasRole]);
  const { isLoading } = useIntrospect({
    onSuccess: (response: IntrospectUserResponse | undefined) => {
      if (response) {
        setDomainUser(response.domainUser);
      }
    }
  });

  return !isLoading ? <Outlet /> : <Loading />;
};
